// モーダル
$(() => {

    $('#commonModal').on('show.bs.modal', function (event) {
        var el          = $(event.relatedTarget)
        var title       = el.data('title').length? el.data('title'): ""
        var message     = el.data('message').length? el.data('message'): ""
        var exec        = el.data('exec').length? el.data('exec'): "はい"
        var cxl         = el.data('cxl').length? el.data('cxl'): "キャンセル"

        var modal = $(this)
        modal.find('.modal-title').text(title)
        modal.find('.modal-body').text(message)
        modal.find('.modal-exec').text(exec)
        modal.find('.modal-cxl').text(cxl)

        $('.modal-exec').click(function(event){
            el.parents('form').submit();
        });
    })

    if (document.getElementById('alert_complete_modal') != null){
        $('#alert_complete_modal').modal('show');
    }

    if (document.getElementById('alert_remand_modal') != null){
        $('#alert_remand_modal').modal('show');
    }

    if (document.getElementById('alert_submission_modal') != null){
        $('#alert_submission_modal').modal('show');
    }

    if (document.getElementById('alert_reapplication_modal') != null){
        $('#alert_reapplication_modal').modal('show');
    }

    if (document.getElementById('alert_forcibly_modal') != null){
        $('#alert_forcibly_modal').modal('show');
    }

    $('.submit_invoice_alert').click(function(){
        $('#invoice_alert_modal').modal('hide');
        $('#common_modal').modal('show');
    });

    $('.submit_invoice_after_4day').click(function(){
        $('#invoice_after_4day_modal').modal('hide');
        $('#submission_modal').modal('show');
    });

    $('.submit_report_after_4day').click(function(){
        $('#report_after_4day_modal').modal('hide');
        $('#submission_modal').modal('show');
    });

    $('.submit_remand_after_approved').click(function(){
        $('#remand_after_approved_modal').modal('hide');
        $('#remand_modal').modal('show');
    });

    if (document.getElementById('registed_admin_modal') != null){
        $('#registed_admin_modal').modal('show');
    }

    if (document.getElementById('etc_billing_modal') != null){
        $('#etc_billing_modal').modal('show');
    }

    // ヘルスチェック 満足度
    $('.health_check_satisfaction_item').click(function(){
        $('.health_check_satisfaction_item').removeClass('select');
        $(this).addClass('select');

        var befoe_satisfaction_value = $('input[name="satisfaction"]').val();
        var radio_value = $('input[name="health_check_satisfaction_radio_item"]:checked').val();
        var value = $(this).val();

        if (value == 5) {
            $('#health_check_satisfaction_other_reason').slideDown();

            if (radio_value !== undefined) {
                value = radio_value;
            }
        } else if ($.inArray(befoe_satisfaction_value,[5,6,7,8]) && $.inArray(value,[1,2,3,4])) {
            $('#health_check_satisfaction_other_reason').slideUp();
        }

        $('input[name="satisfaction"]').val(value);

        if ($('.js-form-submit').prop('disabled')) {
            $('.js-form-submit').prop("disabled", false);
        }
    });

    // ヘルスチェック 満足度(その他の理由)
    $('input[name="health_check_satisfaction_radio_item"]').change(function(){
        $('input[name="satisfaction"]').val($(this).val());
    });

    // PTNアドバイザリー型　前月の稼働内容コピーモーダル
    $('.report_advisory_copy').click(function(){
        event.preventDefault();
        $('#report_advisory_copy_modal').modal('show');
    });

    // PTNアドバイザリー型　前月の稼働内容コピー実行
    $('.modal-exec-report_advisory_copy').click(function(){
        let currentUrlArr = location.pathname.split("/");
        let actor = currentUrlArr[1];
        let condition_id = currentUrlArr[3];
        let term = currentUrlArr[4];
        window.location.href = '/'+ actor +'/reports/'+ condition_id +'/'+ term +'/advisory_copy';
    });

    // 請求情報乖離アラート
    if (document.getElementById('deviation-biller_modal') != null){
        $('#deviation-biller_modal').modal('show');
        $('.deviation-biller-exec').click(function(){
            $('#deviation-biller').submit();
        });
    }

    // 一括検収・承認、一括リマインド確認モーダル
    $('.bulk_confirm').click(function(){
        let count = $('.b-checkbox:checked').length;
        $('.bulk_num').text(count);
        $('#bulk_confirm_modal').modal('show');
    });

    // 一括検収・承認、一括リマインド実行
    $('.bulk_confirm_exec').click(function(){
        $('#bulk').submit();
    });
    
});
